var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},_vm._l((_vm.menuItems),function(item,index){return _c('div',{key:index,staticClass:"menu-item",on:{"click":function($event){return _vm.selectMenu(item)}}},[_c('h3',[_vm._v(_vm._s(item.mingc))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }